import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { NavigationButton } from './navigation-link'

export default function NavigationUser({
  userFullName,
  profilePath,
  active,
  authenticityToken,
  context,
}) {
  const [isOpen, setIsOpen] = useState(false)

  const handleEscape = event => {
    if (event.key === 'Escape') {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleEscape)
    return () => {
      window.removeEventListener('keydown', handleEscape)
    }
  }, [])

  return (
    <li
      className={`
    ${
      context !== 'toolbar'
        ? 'tw-pb-2 md:tw-pb-0 md:tw-pr-4 lg:tw-px-4'
        : 'tw-pb-2'
    }
    tw-p-0`}>
      <NavigationButton
        inToolbar={context === 'toolbar'}
        active={active}
        onClick={() => setIsOpen(!isOpen)}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : 'false'}>
        {userFullName}
        <i className="fas fa-caret-down tw-ml-1"></i>
      </NavigationButton>
      {isOpen && (
        <>
          <button
            onClick={() => setIsOpen(false)}
            tabIndex={-1}
            className="tw-fixed tw-inset-0 tw-opacity-0 tw-h-full tw-w-full tw-cursor-default"></button>
          <div
            className={`
        ${context !== 'toolbar' ? 'md:tw-w-40 md:tw-absolute' : ''}
        tw-origin-top-right tw-relative  tw-right-auto tw-mt-2 tw-w-full tw-rounded-md tw-shadow-lg`}>
            <div className="tw-rounded-md tw-bg-white tw-ring-1 tw-ring-black tw-ring-opacity-5">
              <div
                className="tw-py-1"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu">
                <a
                  href={profilePath}
                  className="tw-block tw-px-4 tw-py-2 tw-text-sm tw-leading-5 tw-text-system-grey-600 hover:tw-bg-system-grey-50 hover:tw-text-primary hover:tw-no-underline focus:tw-outline-none focus:tw-bg-system-grey-50 focus:tw-text-primary"
                  role="menuitem">
                  Profile
                </a>
                <form className="button_to" method="post" action="/logout">
                  <input type="hidden" name="_method" value="delete" />
                  <input
                    type="hidden"
                    name="authenticity_token"
                    value={authenticityToken}
                  />
                  <button
                    type="submit"
                    className="tw-block tw-uppercase tw-bg-transparent tw-border-none tw-w-full tw-text-left tw-px-4 tw-py-2 tw-text-sm tw-leading-5 tw-text-system-grey-600 hover:tw-bg-system-grey-50 hover:tw-text-primary focus:tw-outline-none focus:tw-bg-system-grey-50 focus:tw-text-primary"
                    role="menuitem">
                    Log Out
                  </button>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </li>
  )
}

NavigationUser.propTypes = {
  userFullName: PropTypes.string,
  profilePath: PropTypes.string,
  active: PropTypes.bool,
  authenticityToken: PropTypes.string,
  context: PropTypes.string,
}
